<template>
    <div
        :style="{ '--width': openWidth }"
        :class="{
            'hover:before:w-[--width] hover:before:bg-accent-700/50 hover:before:shadow-[#FFFFFF59]':
                openWidth,
            'before:w-[--width] before:!bg-accent-700/50 before:!shadow-[#FFFFFF59]':
                id === model,
            'before:left-0': textDirection === 'right',
            'flex-row-reverse before:right-0': textDirection === 'left',
        }"
        class="group relative z-20 flex size-12 items-center before:absolute before:top-0 before:z-20 before:size-12 before:overflow-hidden before:rounded-full before:bg-white/70 before:shadow-[0px_0px_35px_0px_transparent_inset] before:backdrop-blur-md before:transition-all before:duration-300"
        @mouseenter="changeActiveCircle">
        <div
            :class="{
                'left-0': textDirection === 'right',
                'right-0': textDirection === 'left',
                'w-[--width]': id === model,
            }"
            class="absolute z-20 h-full w-0 overflow-hidden rounded-full transition-all duration-300 group-hover:w-[--width]">
            <div class="bg-noise"></div>
        </div>
        <div
            :class="{
                'group-hover:left-1 group-hover:top-1 group-hover:size-10 group-hover:bg-white/50':
                    openWidth,
                '!left-1 !top-1 !size-10 !bg-white/50': id === model,
            }"
            class="absolute left-3 top-3 z-20 size-6 rounded-full bg-white/80 transition-all duration-300"></div>
        <div
            ref="text"
            v-html="text"
            :class="{
                'group-hover:opacity-100 group-hover:delay-150': openWidth,
                'opacity-100 delay-150': id === model,
                'ml-16': textDirection === 'right',
                'mr-16': textDirection === 'left',
            }"
            class="pointer-events-none relative z-20 whitespace-nowrap opacity-0 transition-all delay-0 duration-300"></div>
    </div>
</template>

<script setup lang="ts">
const model = defineModel({
    type: [Number, null] as PropType<number | null>,
    required: true,
})

const emit = defineEmits<{
    changeDirectionRotate: [id: number]
}>()

const props = defineProps({
    id: {
        type: Number as PropType<number>,
        required: true,
    },
    textDirection: {
        type: String as PropType<'left' | 'right'>,
        default: 'left',
    },
    text: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
})

const openWidth = ref<string>('0')
const textRef = useTemplateRef('text')

onMounted(() => {
    if (!textRef.value) return
    updateCircle()

    window.addEventListener('resize', updateCircle)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateCircle)
})

watch(
    () => props.text,
    async () => {
        await updateCircle()
    }
)

function changeActiveCircle(): void {
    emit('changeDirectionRotate', props.id)
    model.value = props.id
}

async function updateCircle() {
    await nextTick()
    if (!textRef.value) return

    openWidth.value = textRef.value.scrollWidth / getRemInPixels() + 6 + 'rem'
}

function getRemInPixels(): number {
    return parseFloat(getComputedStyle(document.documentElement).fontSize)
}
</script>
